import { render, staticRenderFns } from "./isSubjectToVat.vue?vue&type=template&id=7aa0ef98&"
import script from "./isSubjectToVat.vue?vue&type=script&lang=ts&"
export * from "./isSubjectToVat.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports